import React from "react";
import Preloader from "../helper/Preloader";
import FooterOne from "../components/FooterOne";
import BottomFooter from "../components/BottomFooter";
import ScrollToTop from "react-scroll-to-top";
import ColorInit from "../helper/ColorInit"; 
import HeaderOneCreateAccount from "../componentsAmazon/HeaderOneCreateAccount";
import Breadcrumb from "../components/Breadcrumb";
import Customerdashbord from "../componentsAmazon/Dashboard/Customerdashbord";

const DashbordCustomer = () => {
 
 
  return (
    <>
      {/* Preloader */}
      <Preloader />

      {/* ScrollToTop */}
      <ScrollToTop smooth color="#232F3F" />

      {/* ColorInit */}
      <ColorInit color={false} />

      {/* Breadcrumb */}
      <Breadcrumb title={"Dashbord"} />

      {/* Conditionally Render WholesaleCenter */}
       <Customerdashbord/>

      {/* FooterOne */}
      <FooterOne />

      {/* BottomFooter */}
      <BottomFooter />
    </>
  );
};

export default DashbordCustomer;
